import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Beneficiaria, BeneficiariaService } from 'src/app/beneficiaria';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchErr } from '../../utils';

@Component({
    selector: 'select-beneficiaria',
    templateUrl: './select-beneficiaria.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectBeneficiariaComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectBeneficiariaComponent implements OnInit, ControlValueAccessor {

    @Input() placeholder: string = 'Beneficiária';
    @Input() required: boolean = false;
    @Input() disabled: boolean = false;
    @Output() beneficiariaChange = new EventEmitter<Beneficiaria>();

    beneficiarias: Beneficiaria[] = [];
    selectedBeneficiaria: Beneficiaria | null = null;
    loading: boolean = false;

    // ControlValueAccessor methods
    private onChange = (value: any) => {};
    private onTouched = () => {};

    constructor(
        private beneficiariaService: BeneficiariaService,
        private snackBar: MatSnackBar
    ) {}

    ngOnInit() {
        this.loadBeneficiarias();
    }

    loadBeneficiarias() {
        this.loading = true;
        this.beneficiariaService.getAll<Beneficiaria>().subscribe({
            next: (res) => {
                this.beneficiarias = res.data;
            },
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    onBeneficiariaChange(beneficiaria: Beneficiaria) {
        this.selectedBeneficiaria = beneficiaria;
        this.onChange(beneficiaria?.id || null);
        this.onTouched();
        this.beneficiariaChange.emit(beneficiaria);
    }

    searchFn(term: string, item: Beneficiaria) {
        term = term.toLocaleLowerCase();
        return item.nome.toLocaleLowerCase().indexOf(term) > -1;
    }

    compareWith(item: any, selected: any) {
        return item && selected && item.id == selected.id;
    }

    // ControlValueAccessor implementation
    writeValue(value: any): void {
        if (value) {
            const beneficiaria = this.beneficiarias.find(b => b.id === value);
            this.selectedBeneficiaria = beneficiaria || null;
        } else {
            this.selectedBeneficiaria = null;
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}